<!-- Hero Section -->
<section class="hero-section">
  <div class="hero-overlay"></div>
  <div class="hero-content">
    <h1 class="hero-title">
      Where UK Educational Excellence<br>
      Meets UAE Student Success
    </h1>
    <p class="hero-subtitle">
      Where video based learning for UK and international programs<br>
      guided by educators who teach the full content.
    </p>
    <button class="btn-book-demo" (click)="bookDemo()">
      Book Your Demo
    </button>
    <div class="hero-links">
      <a href="#" class="hero-link" (click)="scrollToSection('discover')">Discover UK Quality</a>
      <span class="separator">|</span>
      <a href="#" class="hero-link" (click)="scrollToSection('success')">UAE Success</a>
    </div>
  </div>
</section>



<!-- Courses Section -->
<section class="courses-section">
  <div class="container">
    <h2 class="courses-title">Courses We Offer</h2>
    <p class="courses-subtitle">Comprehensive IGCSE Curriculum For All</p>
    <p class="courses-description">
      Every subject taught by UK-certified specialists who live and breathe their discipline.
    </p>
    <button class="btn-book-free-demo" (click)="bookDemo()">Book Free Demo</button>
    
    <div class="courses-grid">
      <div class="course-card" *ngFor="let course of courses">
        <div class="course-icon">
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
            <circle cx="30" cy="30" r="28" stroke="#0099FF" stroke-width="2"/>
            <circle cx="30" cy="30" r="4" fill="#0099FF"/>
            <circle cx="30" cy="15" r="3" fill="#0099FF"/>
            <circle cx="30" cy="45" r="3" fill="#0099FF"/>
            <circle cx="15" cy="30" r="3" fill="#0099FF"/>
            <circle cx="45" cy="30" r="3" fill="#0099FF"/>
            <line x1="30" y1="26" x2="30" y2="18" stroke="#0099FF" stroke-width="2"/>
            <line x1="30" y1="34" x2="30" y2="42" stroke="#0099FF" stroke-width="2"/>
            <line x1="26" y1="30" x2="18" y2="30" stroke="#0099FF" stroke-width="2"/>
            <line x1="34" y1="30" x2="42" y2="30" stroke="#0099FF" stroke-width="2"/>
          </svg>
        </div>
        <h3 class="course-title">{{ course.title }}</h3>
        <p class="course-subjects">{{ course.subjects }}</p>
      </div>
    </div>
  </div>
</section>



<!-- Learning That Fits Section -->
<section class="learning-fits-section">
  <div class="container">
    <div class="learning-wrapper">
      <div class="learning-content">
        <h2 class="learning-title">Learning That Fits Your Life</h2>
        <p class="learning-subtitle"><strong>7-steps process designed for confidence, clarity, and measurable improvement.</strong></p>
        
        <div class="learning-steps">
          <div class="step-item" *ngFor="let step of learningSteps">
            <strong>Step {{ step.step }}</strong> {{ step.title }} – {{ step.description }}
          </div>
        </div>
        
        <button class="btn-start-trial" (click)="bookDemo()">Start Free Trial</button>
      </div>
      
      <div class="learning-image">
        <img src="assets/images/uae-learning.png" alt="Learning Environment" class="learning-img">
      </div>
    </div>
  </div>
</section>

<!-- Results That Speak Section -->
<section class="results-section">
        <h2 class="title">Results That Speak</h2>
        <div class="content-wrapper">
            <div class="text-content">
                <ul class="stats-list">
                    <li>90%+ of Sehyog students score A–A* in core subjects</li>
                    <li>More than 10K+ Successful Students and Happy Parents</li>
                </ul>
                <button class="cta-button" (click)="bookDemo()">Book Free Demo</button>
            </div>
            <div class="image-content">
                <img src="assets/images/atopper.png" alt="Happy student with certificate and medal celebrating achievement with confetti">
            </div>
        </div>
    </section>


<!-- Success stories -->

<section class="success-section">
        <h2 class="section-title">Success Stories</h2>
        
        <div class="story-card">
            <div class="student-profile">
                <img src="assets/images/mock-test-sl.png" alt="Aisha Mohammed" class="profile-image">
                <div class="profile-info">
                    <h3 class="student-name">Aisha Mohammed</h3>
                    <div class="info-item">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                            <path d="M2 17l10 5 10-5M2 12l10 5 10-5"/>
                        </svg>
                        <span>Dubai</span>
                    </div>
                    <div class="info-item">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                            <line x1="16" y1="2" x2="16" y2="6"/>
                            <line x1="8" y1="2" x2="8" y2="6"/>
                            <line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                        <span>GEMS Wellington Academy</span>
                    </div>
                    <div class="info-item">
                        <span><strong>Subjects:</strong> Mathematics, Physics, Chemistry</span>
                    </div>
                    <div class="info-item">
                        <span><strong>Results:</strong> C C D → A* A* A in 6 months</span>
                    </div>
                </div>
            </div>

            <div class="story-content">
                <h4 class="story-title">The Story</h4>
                <p class="story-text">
                    Aisha came to us midway through Year 11, panicking about her predicted grades. 
                    Despite being bright and hardworking, she struggled with exam technique and 
                    time management under pressure.
                </p>
                
                <div class="what-we-did">
                    <p class="what-we-did-title">What we did:</p>
                    <ul class="action-list">
                        <li>- Identified her specific weaknesses through diagnostic assessment</li>
                        <li>- Created a focused revision plan prioritizing high-impact topics</li>
                        <li>- Taught exam strategies and time management techniques</li>
                        <li>- Built her confidence through regular mock exams</li>
                        <li>- Provided intensive support in the final 8 weeks</li>
                    </ul>
                </div>
                
                <p class="result-text">
                    <strong>The result?:</strong> <br>
                    Three A* grades and a place at Imperial College London to study Chemical Engineering.
                </p>
            </div>
        </div>
    </section>


    <!-- RAR System -->

    <section class="rar-section">
        <h2 class="section-title">Our Proprietary RAR System</h2>
        
        <div class="features-grid">
            <div class="feature-card">
                <img src="assets/images/sd-example.png" alt="Student Performance Dashboard" class="feature-image">
                <div class="feature-content">
                    <h3 class="feature-title">Student Dashboard</h3>
                    <p class="feature-description">
                        A modern, data-driven interface that visualizes each student's academic progress through charts, 
                        scores, and attendance insights, helping track learning trends at a glance.
                    </p>
                </div>
            </div>

            <div class="feature-card">
                <img src="assets/images/rar-example.png" alt="Result Analysis Report" class="feature-image">
                <div class="feature-content">
                    <h3 class="feature-title">Result Analysis Report (RAR)</h3>
                    <p class="feature-description">
                        A detailed performance summary comparing individual results with peers, showing paper-wise 
                        scores, ranks, and section-wise analysis for deeper academic evaluation.
                    </p>
                </div>
            </div>
        </div>
    </section>


    <!-- Course section -->

    <section class="programmes-section">
  <!-- IGCSE Excellence Section (Standalone) -->
  <div class="programme-card">
    <h2 class="main-title">Why Our Success Translates to IGCSE Excellence</h2>
    <p class="subtitle">From GCSE Leaders to IGCSE Masters: Your Academic Edge Starts Here.</p>
    
    <p class="intro-text">
      We are a UK-based tutoring team with a deep heritage in mastering the British curriculum. Our success is rooted 
      in years of experience teaching GCSE students in the UK, using proven teaching methodologies, exam techniques, 
      and foundational knowledge required for IGCSE excellence.
    </p>

    <div class="feature-grid">
      <div class="feature-box">
        <h4>World-Class Standards</h4>
        <p>We import the same demanding quality and rigor from GCSE methodologies used in the UK.</p>
      </div>

      <div class="feature-box">
        <h4>Exam Rigour</h4>
        <p>Our tutors understand the nuances of Cambridge and Edexcel, helping students achieve top marks consistently.</p>
      </div>

      <div class="feature-box">
        <h4>Proven Strategies</h4>
        <p>We don't guess—we use results-driven, UK-centric strategies directly applied to your child's IGCSE preparation.</p>
      </div>
    </div>
  </div>

  <!-- Tabbed Programme Section -->
  <div class="tabs-container">
    <div class="tab-buttons">
      <button 
        class="tab-button" 
        [class.active]="isActiveTab('igcse')"
        (click)="selectTab('igcse')">
        IGCSE Programme
      </button>
      <button 
        class="tab-button" 
        [class.active]="isActiveTab('ib')"
        (click)="selectTab('ib')">
        IB & IBDP
      </button>
      <button 
        class="tab-button" 
        [class.active]="isActiveTab('cbse')"
        (click)="selectTab('cbse')">
        CBSE Programme
      </button>
    </div>

    <!-- IGCSE Tab Content -->
    <div class="tab-content" [class.active]="isActiveTab('igcse')">
      <h2 class="program-title">IGCSE Programme (Years 7–13)</h2>
      <p class="program-subtitle">Complete subject coverage for Cambridge IGCSE & Pearson Edexcel International GCSE</p>
      
      <p class="description">
        Our IGCSE programme covers all core and optional subjects with UK-qualified specialists who understand the examination boards inside out.
      </p>

      <h3 class="section-heading">Subjects Offered:</h3>
      <ul class="content-list">
        <li>Mathematics – Foundation & Higher Tier</li>
        <li>English Language & Literature – Speaking, writing, and comprehension mastery</li>
        <li>Sciences – Physics, Chemistry, Biology (separate or combined)</li>
        <li>Languages – Arabic, French, Spanish (available on request)</li>
      </ul>

      <h3 class="section-heading">What Makes Our IGCSE Tutoring Different:</h3>
      <ul class="content-list">
        <li>Deep expertise in Cambridge and Edexcel mark schemes</li>
        <li>Exam technique training for Papers 1, 2, 3, and 4</li>
        <li>Past paper practice with real examiner insights</li>
        <li>Coursework and controlled assessment support</li>
        <li>Personalized study plans aligned to your school's timeline</li>
      </ul>
    </div>

    <!-- IB Tab Content -->
    <div class="tab-content" [class.active]="isActiveTab('ib')">
      <h2 class="program-title">IB & IBDP Programme</h2>
      <p class="program-subtitle">Comprehensive support for MYP and Diploma Programme students</p>
      
      <p class="description">
        The IB curriculum demands critical thinking, research skills, and interdisciplinary learning. 
        Our IB specialists guide students through every component with expertise and care.
      </p>

      <h3 class="section-heading">MYP (Years 7–10) Support:</h3>
      <ul class="content-list">
        <li>Subject-specific tutoring across all eight subject groups</li>
        <li>Personal Project mentorship and timeline management</li>
        <li>Criterion-based assessment understanding</li>
        <li>Interdisciplinary learning support</li>
      </ul>

      <h3 class="section-heading">IBDP (Years 11–13) Support:</h3>
      <ul class="content-list">
        <li>Six Subject Groups – HL and SL options across all disciplines</li>
        <li>Theory of Knowledge (TOK) – Essay writing and presentation coaching</li>
        <li>Extended Essay (EE) – Research question development, structure, and academic writing</li>
        <li>CAS Portfolio – Activity planning and reflection guidance</li>
        <li>Exam Preparation – Paper 1, 2, and 3 strategies for all subjects</li>
      </ul>

      <p class="description" style="margin-top: 25px;">
        <strong>Popular IBDP Subjects We Offer:</strong> Mathematics (AA/AI), English A, Physics, Chemistry and Biology
      </p>

      <h3 class="section-heading">What Makes Our IB Tutoring Different:</h3>
      <ul class="content-list">
        <li>IB examiners and experienced DP teachers on our team</li>
        <li>Understanding of command terms and assessment objectives</li>
        <li>IA (Internal Assessment) guidance and feedback</li>
        <li>Time management strategies for DP workload</li>
        <li>University application integration (UCAS, Common App)</li>
      </ul>
    </div>

    <!-- CBSE Tab Content -->
    <div class="tab-content" [class.active]="isActiveTab('cbse')">
      <h2 class="program-title">CBSE Programme (Grades 9–12)</h2>
      <p class="program-subtitle">Specialized coaching for Indian curriculum students in the UAE</p>

      <h3 class="section-heading">Subjects Offered:</h3>
      <ul class="content-list">
        <li>Mathematics – Standard & Advanced levels</li>
        <li>Science Stream – Physics, Chemistry, Biology</li>
        <li>English – Core and Elective options</li>
      </ul>

      <h3 class="section-heading">What Makes Our CBSE Tutoring Different:</h3>
      <ul class="content-list">
        <li>Chapter-wise concept clarity and problem-solving</li>
        <li>Board exam pattern familiarity and answer-writing techniques</li>
        <li>Regular topic tests and board-style mock examinations</li>
        <li>Support for CBSE practical examinations and internal assessments</li>
      </ul>
    </div>
  </div>
</section>

    <!-- Launching  -->

    <div class="uae-hero-container">
        <div class="uae-hero-banner">
            <div class="uae-content-box">
                <h1 class="uae-hero-title">LAUNCHING NOW IN THE UAE!</h1>
                
                <p class="uae-promo-line">
                    Secure the academic advantage for your child and get <span class="uae-discount-badge">50% OFF</span> your first course enrollment.
                </p>
                
                <p class="uae-info-text">
                    Limited slots are available for this introductory Early Bird offer don't miss out on world-class UK tutoring at an introductory rate.
                </p>
                
                <button class="uae-demo-btn" (click)="bookDemo()">Book Free Demo</button>
            </div>
        </div>
    </div>


    <!-- PRICING -->
      <section class="pricing-main-container">
        <h2 class="pricing-header-title">Transparent Pricing</h2>
        
        <div class="pricing-cards-grid">
            <!-- Online Tutoring Card -->
            <div class="pricing-card-wrapper">
                <div class="pricing-card-header">
                    <h3 class="pricing-plan-name">Online Tutoring</h3>
                </div>
                <div class="pricing-features-container">
                    <ul class="pricing-features-list">
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>Personalized lesson plans</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>Paid Zoom account</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>Lesson reports after every lesson</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>SMS & email appointment reminders</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>Dedicated customer support</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>No monthly commitment</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>Pay at the end of the month</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>24 hour free cancellation</span>
                        </li>
                    </ul>
                    <div class="pricing-cta-wrapper">
                        <button class="pricing-book-button" (click)="bookDemo()">Book Free Demo</button>
                    </div>
                </div>
            </div>

            <!-- Premium Tutoring Card -->
            <div class="pricing-card-wrapper">
                <div class="pricing-card-header">
                    <h3 class="pricing-plan-name">Premium Tutoring</h3>
                </div>
                <div class="pricing-features-container">
                    <ul class="pricing-features-list">
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>Personalized lesson plans</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>Paid Zoom account</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>Lesson reports after every lesson</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>SMS & email appointment reminders</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>Dedicated customer support</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>No monthly commitment</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>Pay at the end of the month</span>
                        </li>
                        <li class="pricing-feature-item">
                            <span class="pricing-check-icon"></span>
                            <span>24 hour free cancellation</span>
                        </li>
                    </ul>
                    <div class="pricing-cta-wrapper">
                        <button class="pricing-book-button" (click)="bookDemo()">Book Free Demo</button>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Ready to start -->

     <section class="cta-outer-container">
        <div class="cta-banner-box">
            <h2 class="cta-main-heading">Ready to Start?</h2>
            <button class="cta-action-button" (click)="bookDemo()">Book Your Free Pre-Assessment</button>
            <p class="cta-subtext">Receive your RAR & plan within 48 hours.</p>
        </div>
    </section>


    <!-- ABOUT SECTION -->
     <section class="about-sehyog-wrapper">
        <div class="about-sehyog-content">
            <h2 class="about-main-title">About SEHYOG</h2>
            <p class="about-tagline">Built on Collaboration. Powered by Excellence.</p>
            
            <p class="about-description-text">
                Founded in the UK in 2010, Sehyog meaning "collaboration" in Sanskrit was created on a simple belief: every student deserves expert guidance to reach their full potential.
            </p>
            
            <p class="about-description-text">
                For over 15 years, we've helped thousands of students in the UK achieve top IGCSE and A-Level results. Now, we bring that same educational excellence to the UAE, combining British pedagogy with local understanding.
            </p>
            
            <p class="about-description-text">
                We recognize the unique pressures UAE students face competitive schools, packed schedules, and high expectations. That's why our programs are designed to be accessible, flexible, and results-driven.
            </p>
        </div>
    </section>


    <!-- news letter -->

    <section class="newsletter-outer-wrapper">
        <div class="newsletter-bordered-box">
            <h2 class="newsletter-heading">Sign up for our Newsletter</h2>
            
            <form class="newsletter-form-container">
                <input 
                    type="email" 
                    class="newsletter-email-input" 
                    placeholder="Enter Your Email"
                    required
                >
                <button type="submit" class="newsletter-submit-btn">Stay Updated</button>
            </form>
        </div>
    </section>


    <!-- FAQ -->

   <section class="faq-container-main">
  <h2 class="faq-page-title">FAQs</h2>

  <div class="faq-accordion-item" 
       *ngFor="let faq of faqs; let i = index" 
       [class.active]="faq.isOpen">
    <div class="faq-question-header" (click)="toggleFaq(i)">
      <span class="faq-question-text">{{ faq.question }}</span>
      <svg class="faq-toggle-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M19 9l-7 7-7-7"/>
      </svg>
    </div>
    <div class="faq-answer-content">
      <div class="faq-answer-inner">
        <p *ngIf="faq.answer">{{ faq.answer }}</p>
        <div *ngIf="faq.answerHtml" [innerHTML]="faq.answerHtml"></div>
      </div>
    </div>
  </div>
</section>

